import axios from 'axios';
import { API_CONFIG, STORAGE_KEYS } from '../../constants';
import { IAttributes } from 'types/attributes/attributes.types';

const SERVER_URL = API_CONFIG.SERVER_URL;

// Create axios instance with default config
const api = axios.create({
    baseURL: SERVER_URL,
});

// Add request interceptor to include token in headers
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
        if (token && config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle token expiration
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            // Token expired or invalid, redirect to login
            localStorage.removeItem(STORAGE_KEYS.TOKEN);
            localStorage.removeItem(STORAGE_KEYS.USER);
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export const getAttributes = async (): Promise<IAttributes[]> => {
    try {
        const response = await api.get('/attributes');
        return response.data;
    } catch (error) {
        console.error('Error fetching attributes:', error);
        throw error;
    }
};